import React, { Component } from 'react';
import './Preview.css';
import { resetIconStyle } from '../Board/Board.js';
import filmFrame from '../../../shared/assets/game/filmFrame.svg';
import play from '../../../shared/assets/game/play.svg';

class Preview extends Component {

  animate() {
    document.getElementById('playButton').style.opacity = '0';
    resetIconStyle(this.props.numIcons);
    
    let iconOrder = this.props.iconOrder;
    let i = 0;
    let id = setInterval(() => {

      if (i > 0) {  // clear previous frame, if one exists
        document.querySelector(`img[src='${iconOrder[i-1]}']`).style.opacity = '0';
        document.querySelector(`input[src='${iconOrder[i-1]}']`).style.backgroundColor = 'unset';
      } 
      if (i === this.props.numIcons) {  // reached the last frame
        clearInterval(id);
        document.getElementById('playButton').style.opacity = 'unset';
      } else {  // show frame 
        document.querySelector(`img[src='${iconOrder[i]}']`).style.opacity = '1';
        document.querySelector(`input[src='${iconOrder[i]}']`).style.backgroundColor = 'rgba(95, 131, 166, 0.3)';
        i++;
      }
    }, 400);
  }
  
  render () {
    return (
      <div>
        <div className ='preview'>
          <div className='display'>
            <object data={filmFrame} type='image/svg+xml' aria-label='animation preview'/>
            <input type='image' src={play} id='playButton' alt='play button'
              onClick={() => this.animate()}/>
            {this.props.correctOrder.map((image, i) => 
              <img src={this.props.correctOrder[i]} key={i} className='animation' alt='frame'/>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default Preview;